"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontendStore = void 0;
const models_1 = require("lincd/lib/models");
const Server_1 = require("../utils/Server");
const package_1 = require("../package");
const lincd_server_1 = require("../ontologies/lincd-server");
const InMemoryStore_1 = require("lincd-storage/lib/shapes/InMemoryStore");
const Storage_1 = require("lincd/lib/utils/Storage");
/**
 * Abstract class that makes it easier to create a store for the frontend
 * Which loads all its contents on initialisation and passes all the changes
 * to a provider on the backend
 */
let FrontendStore = class FrontendStore extends InMemoryStore_1.InMemoryStore {
    update(toAdd, toRemove) {
        return super.update(toAdd, toRemove).then(() => {
            return Server_1.Server.call(this, 'update', toAdd, toRemove).then(res => {
                return res;
            });
        });
    }
    setURI(...nodes) {
        return Server_1.Server.call(this, 'setURI', nodes, nodes.map(n => n.uri)).then((uris) => {
            uris.forEach(([oldURI, newURI]) => {
                let node = models_1.NamedNode.getOrCreate(oldURI);
                node.uri = newURI;
            });
        });
    }
    loadContents() {
        return Server_1.Server.call(this, 'loadContents').then((contents) => {
            let graph = Storage_1.Storage.getGraphForStore(this);
            if (contents) {
                this.contents = contents.moveTo(graph, false);
            }
            return this.contents;
        });
    }
    add(quad) {
        return super.add(quad).then(() => {
            return Server_1.Server.call(this, 'add', quad);
        });
    }
    addMultiple(quads) {
        return super.addMultiple(quads).then(() => {
            return Server_1.Server.call(this, 'addMultiple', quads);
        });
    }
    delete(quad) {
        return super.delete(quad).then(() => {
            return Server_1.Server.call(this, 'delete', quad);
        });
    }
    deleteMultiple(quads) {
        return super.deleteMultiple(quads).then(() => {
            return Server_1.Server.call(this, 'deleteMultiple', quads);
        });
    }
};
FrontendStore.targetClass = lincd_server_1.lincdServer.FrontendStore;
FrontendStore = __decorate([
    package_1.linkedShape
], FrontendStore);
exports.FrontendStore = FrontendStore;
//# sourceMappingURL=FrontendStore.js.map